import cn from 'bem-cn';

import { Skeleton, Stack } from '../../UI';

import './PromptInfoAuthor.scss';

const b = cn('prompt-info-author');

export const PromptInfoAuthorSkeleton = () => {
    return (
        <Stack direction="row" justifyContent="space-between" spacing={8} py={12} px={16} className={b('content')}>
            <Stack direction="row" alignItems="center" spacing={12}>
                <Skeleton variant="circular" width={32} height={32} />
                <Stack spacing={4}>
                    <Skeleton width={60} />
                    <Skeleton width={100} />
                </Stack>
            </Stack>
            <Stack direction="row" spacing={8} alignItems="center">
                <Skeleton width={80} />
                <Skeleton variant="rectangular" width={20} height={20} />
            </Stack>
        </Stack>
    );
};
